'use strict';

const React = require('react');

const PropTypes = require('prop-types');

const EnvelopeIcon = require('dibs-vg/dist/react/envelope');
const FacebookIcon = require('dibs-vg/dist/react/facebook');
const PinterestIcon = require('dibs-vg/dist/react/pinterest');

const styles = require('./GalleryPhotoSocial-styles.scss');

const config = [
    { type: 'envelope', Icon: EnvelopeIcon },
    { type: 'facebook', Icon: FacebookIcon },
    { type: 'pinterest', Icon: PinterestIcon },
];

function onClick(type, sharePhoto) {
    return e => {
        e.stopPropagation();
        sharePhoto({ type, e });
    };
}

function GalleryPhotoSocial({ classes, sharePhoto }) {
    return (
        <div className={classes.wrapper}>
            {config.map(({ type, Icon }) => (
                <div className={classes.icon} key={type} onClick={onClick(type, sharePhoto)}>
                    <Icon />
                </div>
            ))}
        </div>
    );
}

GalleryPhotoSocial.propTypes = {
    sharePhoto: PropTypes.func.isRequired,
    classes: PropTypes.shape({
        wrapper: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
    }).isRequired,
};

GalleryPhotoSocial.defaultProps = {
    classes: styles,
};

module.exports = GalleryPhotoSocial;



// WEBPACK FOOTER //
// ./assets/js/gallery/components/GalleryPhotoSocial.jsx